import { Keyboard } from "lucide-react";
import { useShortcutsEnabled } from "@/lib/mailViewPrefs";
import { SHORTCUT_GROUPS } from "@/features/mail/shortcutCatalog";
import { ShortcutKeys } from "@/features/mail/ShortcutsDialog";

export function ShortcutsPage() {
    const [enabled, setEnabled] = useShortcutsEnabled();
    return (
        <div className="mx-auto max-w-2xl">
            <header className="mb-4 flex items-center gap-2">
                <Keyboard className="h-6 w-6 text-primary" aria-hidden />
                <div>
                    <h2 className="text-xl font-semibold">Keyboard shortcuts</h2>
                    <p className="text-sm text-muted-foreground">
                        Gmail-style shortcuts for the mail list and reading pane. Press <kbd className="rounded border bg-muted px-1 font-mono text-xs">?</kbd> in Mail to see them.
                    </p>
                </div>
            </header>

            <div className="mb-4 flex items-center justify-between gap-4 rounded-lg border bg-card p-4 shadow-sm">
                <div>
                    <div className="text-sm font-medium" id="shortcuts-toggle-label">Keyboard shortcuts</div>
                    <div className="text-xs text-muted-foreground">
                        Off stops every single-key shortcut (Ctrl+Enter to send still works). Saved for your account in this browser.
                    </div>
                </div>
                <button
                    type="button"
                    role="switch"
                    aria-checked={enabled}
                    aria-labelledby="shortcuts-toggle-label"
                    onClick={() => setEnabled(!enabled)}
                    className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary ${enabled ? "bg-primary" : "bg-muted-foreground/30"}`}
                >
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${enabled ? "translate-x-4" : "translate-x-0.5"}`} />
                </button>
            </div>

            <div className={`space-y-4 ${enabled ? "" : "opacity-60"}`}>
                {SHORTCUT_GROUPS.map((group) => (
                    <section key={group.section} className="rounded-lg border bg-card p-4 shadow-sm">
                        <h3 className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                            {group.section}
                        </h3>
                        <dl className="divide-y text-sm">
                            {group.items.map((item) => (
                                <div key={item.description} className="flex items-center justify-between gap-4 py-2">
                                    <dt>{item.description}</dt>
                                    <dd><ShortcutKeys item={item} /></dd>
                                </div>
                            ))}
                        </dl>
                    </section>
                ))}
            </div>
        </div>
    );
}
